// agGridLocaleText.js
export const agGridLocaleText = (getLocaleText) => ({
  page: getLocaleText("page"),
  more: getLocaleText("more"),
  to: getLocaleText("to"),
  of: getLocaleText("of"),
  next: getLocaleText("next"),
  last: getLocaleText("last"),
  first: getLocaleText("first"),
  previous: getLocaleText("previous"),
  loadingOoo: getLocaleText("loadingOoo"),

  // Filters
  noRowsToShow: getLocaleText("noRowsToShow"),
  applyFilter: getLocaleText("applyFilter"),
  resetFilter: getLocaleText("resetFilter"),
  clearFilter: getLocaleText("clearFilter"),
  cancelFilter: getLocaleText("cancelFilter"),
  filterOoo: getLocaleText("filterOoo"),
  searchOoo: getLocaleText("searchOoo"),

  // Column Options
  columns: getLocaleText("columns"),
  filters: getLocaleText("filters"),
  pivotMode: getLocaleText("pivotMode"),
  groups: getLocaleText("groups"),
  values: getLocaleText("values"),
  pivots: getLocaleText("pivots"),
  group: getLocaleText("group"),
  rowGroupColumnsEmptyMessage: getLocaleText("rowGroupColumnsEmptyMessage"),
  valuesColumnsEmptyMessage: getLocaleText("valuesColumnsEmptyMessage"),
  pivotColumnsEmptyMessage: getLocaleText("pivotColumnsEmptyMessage"),

  // Actions and Menus
  toolPanelButton: getLocaleText("toolPanelButton"),
  noPivotChartAvailable: getLocaleText("noPivotChartAvailable"),
  pivotChart: getLocaleText("pivotChart"),
  export: getLocaleText("export"),
  csvExport: getLocaleText("csvExport"),
  excelExport: getLocaleText("excelExport"),
  copy: getLocaleText("copy"),
  copyWithHeaders: getLocaleText("copyWithHeaders"),
  ctrlC: getLocaleText("ctrlC"),
  paste: getLocaleText("paste"),

  // Column Pinning
  pinColumn: getLocaleText("pinColumn"),
  pinLeft: getLocaleText("pinLeft"),
  pinRight: getLocaleText("pinRight"),
  noPin: getLocaleText("noPin"),

  // Column Sizing
  autosizeThisColumn: getLocaleText("autosizeThisColumn"),
  autosizeAllColumns: getLocaleText("autosizeAllColumns"),

  // Grouping
  groupBy: getLocaleText("groupBy"),
  ungroupBy: getLocaleText("ungroupBy"),
  resetColumns: getLocaleText("resetColumns"),

  // Row Expansion
  expandAll: getLocaleText("expandAll"),
  collapseAll: getLocaleText("collapseAll"),

  // Copying Feedback
  copySuccess: getLocaleText("copySuccess"),
  copyFail: getLocaleText("copyFail"),

  // Charting
  chartMenu: getLocaleText("chartMenu"),
  advancedFilter: getLocaleText("advancedFilter"),
  selectAllSearchResults: getLocaleText("selectAllSearchResults"),
  notContainsBlank: getLocaleText("notContainsBlank"),
  dateFormatOoo: getLocaleText("dateFormatOoo"),
  pivotChartTitle: getLocaleText("pivotChartTitle"),
  chartDownload: getLocaleText("chartDownload"),
  chartRange: getLocaleText("chartRange"),

  // Aggregation
  aggregationSum: getLocaleText("aggregationSum"),
  aggregationMin: getLocaleText("aggregationMin"),
  aggregationMax: getLocaleText("aggregationMax"),
  aggregationAverage: getLocaleText("aggregationAverage"),
  aggregationCount: getLocaleText("aggregationCount"),
  aggregationFirst: getLocaleText("aggregationFirst"),
  aggregationLast: getLocaleText("aggregationLast"),

  // Miscellaneous
  loading: getLocaleText("loading"),
  noDataToChart: getLocaleText("noDataToChart"),
  saveAs: getLocaleText("saveAs"),
  autoSize: getLocaleText("autoSize"),
  pivotModeOn: getLocaleText("pivotModeOn"),
  pivotModeOff: getLocaleText("pivotModeOff"),
  chartTypes: getLocaleText("chartTypes"),
  seriesChartType: getLocaleText("seriesChartType"),
  defaultChartType: getLocaleText("defaultChartType"),
  groupedBar: getLocaleText("groupedBar"),
  stackedBar: getLocaleText("stackedBar"),
  normalizedBar: getLocaleText("normalizedBar"),
  groupedColumn: getLocaleText("groupedColumn"),
  stackedColumn: getLocaleText("stackedColumn"),
  normalizedColumn: getLocaleText("normalizedColumn"),
  line: getLocaleText("line"),
  area: getLocaleText("area"),
  stackedArea: getLocaleText("stackedArea"),
  normalizedArea: getLocaleText("normalizedArea"),
  pie: getLocaleText("pie"),
  doughnut: getLocaleText("doughnut"),
  scatter: getLocaleText("scatter"),
  bubble: getLocaleText("bubble"),
  histogram: getLocaleText("histogram"),
  columnChart: getLocaleText("columnChart"),
  barChart: getLocaleText("barChart"),
  pieChart: getLocaleText("pieChart"),
  lineChart: getLocaleText("lineChart"),
  areaChart: getLocaleText("areaChart"),
  scatterChart: getLocaleText("scatterChart"),
  resetChart: getLocaleText("resetChart"),

  // Filter Conditions
  equals: getLocaleText("equals"),
  notEqual: getLocaleText("notEqual"),
  lessThan: getLocaleText("lessThan"),
  greaterThan: getLocaleText("greaterThan"),
  lessThanOrEqual: getLocaleText("lessThanOrEqual"),
  greaterThanOrEqual: getLocaleText("greaterThanOrEqual"),
  inRange: getLocaleText("inRange"),
  contains: getLocaleText("contains"),
  notContains: getLocaleText("notContains"),
  startsWith: getLocaleText("startsWith"),
  endsWith: getLocaleText("endsWith"),
  blank: getLocaleText("blanks"),
  notBlank: getLocaleText("notContainsBlank"),

  // Sorting
  ascending: getLocaleText("ascending"), // Ascending
  descending: getLocaleText("descending"), // Descending
  andCondition: getLocaleText("and"),
  orCondition: getLocaleText("or"),
});
